import { useQuery } from "react-query";
import { request } from "../../../config/helpers/axios-instance";

export const GetPartners = (type = '', name = '') => {
    let params = {};
    if (type) {
        params.type = type;
    }
    if (name) {
        params.name = name;
    }
    return useQuery(["get-partners", type, name], () => {
        return request({
            url: `/partner/admin`,
            method: "GET",
            params: params
        })
    })
}